import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import FlexRow from '../../../layout/flex/row.gjs';
import PrimaryButton from '../../../action/button/primary.gjs';
import SecondaryButton from '../../../action/button/secondary.gjs';
import Super from '../../../modal/shared/footer-cta.gjs';

export const ALIGN_SELF_DEFAULT = 'flex-end';
export const GAP_DEFAULT = '8px';

const METADATA = Metadata.define({
  description: 'Footer CTA for full-screen modal with optional back button.',
  meta: {
    backBtnAction: Arg.action({ description: 'Action for back button when currentStep > 1' }),
    currentStep: Arg.number({ description: 'Current step index' }),
    stepCount: Arg.number({ description: 'Total step count' }),
  },
  omits: ['beforeClose', 'close'],
  name: 'Footer Cta',
});

export default class SpdsModalFullScreenFooterCta extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-full-screen-footer-cta-container';

  get alignSelf() {
    return this.args.alignSelf ?? ALIGN_SELF_DEFAULT;
  }

  get gap() {
    return this.args.gap ?? GAP_DEFAULT;
  }

  get showBackBtn() {
    return this.args.currentStep > 1;
  }

  <template>
    <FlexRow
      class="spds-modal-full-screen-footer-back-container"
      data-test-spds-modal-full-screen-back-container
      {{this.validateArguments}}
      ...attributes
    >
      {{#if this.showBackBtn}}
        <SecondaryButton
          aria-label="back"
          class="spds-modal-full-screen-footer-back-btn"
          data-test-spds-modal-full-screen-back-button
          type="button"
          {{on "click" @backBtnAction}}
        >
          Back
        </SecondaryButton>
      {{/if}}
    </FlexRow>
    <FlexRow
      @alignSelf={{this.alignSelf}}
      @gap={{this.gap}}
      class={{this.classes}}
      data-test-spds-modal-full-screen-cta-container
    >
      {{#if this.showSecondaryButton}}
        <SecondaryButton
          @disabled={{@secondaryBtnDisabled}}
          class="button secondary spds-modal-full-screen-secondary-btn"
          data-test-spds-modal-full-screen-cta-secondary-button
          type="button"
          {{on "click" @secondaryBtnAction}}
        >
          {{@secondaryBtnText}}
        </SecondaryButton>
      {{/if}}
      <PrimaryButton
        @disabled={{@primaryBtnDisabled}}
        class="{{this.primaryBtnType}} spds-modal-full-screen-primary-btn"
        data-test-spds-modal-full-screen-cta-primary-button
        type="button"
        {{on "click" @primaryBtnAction}}
      >
        {{@primaryBtnText}}
      </PrimaryButton>
    </FlexRow>
  </template>
}

export const MODAL_FULL_SCREEN_FOOTER_CTA_METADATA = SpdsModalFullScreenFooterCta.metadata;
